import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, map } from "rxjs";
import {
  AnalyticsRemindersGranularity,
  AnalyticsRemindersHistory,
  AnalyticsRemindersSnapshot
} from "src/app/backend/models/analytics-reminders";
import { environment } from "src/environments/environment";

@Injectable()
export class AnalyticsRemindersBackend {
  private readonly http = inject(HttpClient);

  loadSnapshot({
    from,
    to
  }: {
    from?: string;
    to?: string;
  } = {}): Observable<AnalyticsRemindersSnapshot> {
    const params: Record<string, string> = {};
    if (from) {
      params["from"] = from;
    }
    if (to) {
      params["to"] = to;
    }

    return this.http.get<AnalyticsRemindersSnapshot>(
      `${environment.snoots.api.analytics}/kpis/reminders`,
      { params }
    );
  }

  loadHistories({
    from,
    to,
    granularity
  }: {
    from: string;
    to: string;
    granularity: AnalyticsRemindersGranularity;
  }): Observable<AnalyticsRemindersHistory[]> {
    return this.http
      .get<{ count: number; items: AnalyticsRemindersHistory[] }>(
        `${environment.snoots.api.analytics}/reminders`,
        {
          params: {
            from,
            to,
            granularity
          }
        }
      )
      .pipe(map((response) => response.items));
  }
}
